module.exports = __webpack_public_path__ + "img/study_currenttitle_bg.fc9d1446.png";